import React, { useState, useEffect } from "react";
import axios from "axios";
import { SelectCustom } from "../componentes/selectComponent";
import { InputCustom } from "../componentes/inputComponent";
import { InputCustomDate } from "../componentes/inputComponentDate";
import {
  Form,
  Space,
  Row,
  Col,
  Button,
  Checkbox,
  Select,
  DatePicker,
  TimePicker,
  Modal,
  Switch
} from "antd";
import {
  SettingOutlined,
  FileProtectOutlined,
  TeamOutlined,
  DashboardOutlined,
  PlusOutlined,
  InfoCircleOutlined,
  SyncOutlined,
  SafetyCertificateOutlined
} from "@ant-design/icons";
import ruedaRoja from "../rueda.png";
import { TablaCompleta } from "../tablas/tabla_simple";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import moment from "moment";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { manejarError } from "../manejo_errores";
import { HeadersAuth } from "../funciones_utiles";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import { useMediaQuery } from "react-responsive";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { SelectCustomDate } from "../componentes/SelectComponentDate";
import { Popconfirm } from 'antd';
import { ModalNotificacion } from "../componentes/modalNotificacion";
dayjs.extend(customParseFormat);

export const GestionCarreras = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  // Estados del Componente
  const MySwal = withReactContent(Swal);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    id_campeonato: "",
    id_circuito: "",
    dia: "",
    diaCierre: "",
    horarioCierre: "",
    categorias: [],
    requiereSerieCubiertas: false,
    requierePrecintos: false,
    requiereLicenciaTitularGeneral: false,
    requiereLicenciaInvitadoGeneral: false,
  });
  const [fetchDatos, setFetchDatos] = useState([]); // Guarda los datos de las carreras obtenidos del backend
  const [refresh, setRefresh] = useState(""); // Se utiliza para forzar la actualización de la lista de carreras
  const [idUnico, setIdUnico] = useState(); // ID de la carrera seleccionada para edición
  const [campeonatos, setCampeonatos] = useState([]);
  const [circuitos, setCircuitos] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [carreraInvitado, setCarreraInvitado] = useState(false);
  const [abrirModalCate, setAbrirModalCate] = useState(false);
  const [modoPilotoInvitado, setModoPilotoInvitado] = useState(false);
  const [editarModoInvitado, setEditarModoInvitado] = useState(false);
  const [abrirModalNotificacion, setAbrirModalNotificacion] = useState(false);
  const [dataNotificacion, setDataNotificacion] = useState([]);
  const [eliminarId, setEliminarId] = useState(null);
  const [modalConfiguracionCarrera, setModalConfiguracionCarrera] = useState(false);
  const [modalConfigDetalleVisible, setModalConfigDetalleVisible] = useState(false);
  const [carreraConfigSeleccionada, setCarreraConfigSeleccionada] = useState(null);
  const [modalEstadoVisible, setModalEstadoVisible] = useState(false);
  const [carreraEstadoSeleccionada, setCarreraEstadoSeleccionada] = useState(null);
  const [nuevoEstado, setNuevoEstado] = useState("ACTIVA");
  const [guardandoEstado, setGuardandoEstado] = useState(false);
  const [inscripcionAbierta, setInscripcionAbierta] = useState(true);

  // Carga inicial de datos
  useEffect(() => {
    fetchCampeonatos(sesion.id_asociacion);
    fetchCircuitos(sesion.id_asociacion);
    fetchCategorias(sesion.id_asociacion);
    fetchCarreras(sesion.id_asociacion);
  }, [sesion.id_asociacion, refresh]);

  // Obtener campeonatos
  const fetchCampeonatos = async (id_asociacion) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMINIO +
        `/campeonato/asociacion/${id_asociacion}`,
        HeadersAuth
      );
      const campeonatosConLabel = response.data.map((c) => ({
        ...c,
        label: `${c.nombre_campeonato} (${c.año})`,
      }));

      setCampeonatos(campeonatosConLabel);
      setMostrarBotonLimpiar(false);
    } catch (error) {
      manejarAlertas("error", manejarError(error));
      // console.error("Error al obtener campeonatos:", error);
    }
  };

  // Obtener circuitos
  const fetchCircuitos = async (id_asociacion) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMINIO + `/circuito/asociacion/${id_asociacion}`,
        HeadersAuth
      );

      setCircuitos(response.data);
    } catch (error) {
      manejarAlertas("error","Error al obtener circuitos.");
      // console.error("Error al obtener circuitos:", error);
    }
  };

  // Obtener categorías
  const fetchCategorias = async (id_asociacion) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMINIO +
        `/categoria/asociacion/${id_asociacion}`,
        HeadersAuth
      );
      setCategorias(response.data);
    } catch (error) {
      manejarAlertas("error", "Error al obtener categorías.");

      console.error("Error al obtener categorías:", error);
    }
  };

  // Obtener carreras
  const fetchCarreras = async (id_asociacion) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMINIO + `/carrera/asociacion/${id_asociacion}`,
        HeadersAuth
      );
      setFetchDatos(response.data);
      // console.log("datos de carreras", response.data)
    } catch (error) {
      manejarAlertas("error", "Error al obtener carreras.");

      console.error("Error al obtener carreras:", error);
    }
  };

  // Manejo de cambios en el formulario
  const handleChange = (e) => {
    const { id, value } = e.target;
    setTempDatosFormulario((prev) => ({
      ...prev,
      [id]: value,
    }));
  };
  const limpiarCampos = () => {
    setTempDatosFormulario({
      id_campeonato: "",
      id_circuito: "",
      dia: "",
      dia_prueba: "",
      diaCierre: "",
      horarioCierre: "",
      categorias: [],
      requiereSerieCubiertas: false,
      requierePrecintos: false,
      requiereLicenciaTitularGeneral: false,
      requiereLicenciaInvitadoGeneral: false,
    });

    setIdUnico(null);
    setModoPilotoInvitado(false);
    setMostrarBotonLimpiar(false);
    setInscripcionAbierta(true);
  };
  // Función para mostrar el formulario y ocultar el botón
  const mostrarFormularioHandler = () => {
    setMostrarFormulario(true);
    setMostrarBotonLimpiar(false);
  };
  // Manejo de selección de categorías
  const handleCategoriaChange = (idsSeleccionados) => {
    setTempDatosFormulario((prev) => ({
      ...prev,
      categorias: idsSeleccionados.map((id) => {
        const catExistente = (prev.categorias || []).find(
          (cat) => Number(cat.id_categoria) === Number(id)
        );

        return {
          id_categoria: Number(id),
          invitado: catExistente?.invitado || false,
          requiereLicenciaTitular:
            catExistente?.requiereLicenciaTitular ??
            !!prev.requiereLicenciaTitularGeneral,
          requiereLicenciaInvitado:
            catExistente?.requiereLicenciaInvitado || false,
        };
      }),
    }));
  };

  const handleCategoriaInvitadoChange = (idsSeleccionados) => {
    setTempDatosFormulario((prev) => ({
      ...prev,
      categorias: prev.categorias.map((cat) => {
        const tieneInvitado = idsSeleccionados.includes(Number(cat.id_categoria));

        return {
          ...cat,
          invitado: tieneInvitado,
          requiereLicenciaInvitado: tieneInvitado
            ? !!prev.requiereLicenciaInvitadoGeneral
            : false,
        };
      }),
    }));
  };

  const handleModoInvitadoGeneral = (checked) => {
    setModoPilotoInvitado(checked);

    setTempDatosFormulario((prev) => ({
      ...prev,
      requiereLicenciaInvitadoGeneral: checked
        ? prev.requiereLicenciaInvitadoGeneral
        : false,
      categorias: prev.categorias.map((cat) => ({
        ...cat,
        invitado: checked ? cat.invitado : false,
        requiereLicenciaInvitado: checked
          ? cat.requiereLicenciaInvitado
          : false,
      })),
    }));
  };

  const handleInscripcionAbiertaChange = (checked) => {
    setInscripcionAbierta(checked);

    if (!checked) {
      setTempDatosFormulario((prev) => ({
        ...prev,
        diaCierre: null,
        horarioCierre: null,
      }));
    }
  };

  const handleHoraChange = (e, campo) => {
    const { value } = e.target;

    const nuevaFecha = value ? dayjs(value, "HH:mm").toDate() : null;

    setTempDatosFormulario((prev) => ({
      ...prev,
      [campo]: nuevaFecha,
    }));
  };

  const handleFechaChange = (e, campo) => {
    const { value } = e.target;

    // Convertir el valor del input a una fecha válida
    const nuevaFecha = value ? moment(value, "YYYY-MM-DD").toDate() : null;
  
    // Actualizar el estado temporal del formulario
    setTempDatosFormulario((prev) => ({
      ...prev,
      [campo]: nuevaFecha,
    }));
  
    // Validación específica para "Día Carrera"
    if (campo === "dia") {
      const diaPrueba = tempDatosFormulario.dia_prueba;
      const diaCarrera = nuevaFecha;
  
      // Verificar si ambas fechas están definidas
      if (diaPrueba && diaCarrera) {
        const diffDays = moment(diaCarrera).diff(moment(diaPrueba), "days");
  
        // Validar la diferencia de días
        if (diffDays > 10) {
          // Swal.fire({
          //   title: "Error",
          //   text: "La fecha de carrera no puede ser más de 10 días después de la fecha de prueba.",
          //   icon: "error",
          // });
          manejarAlertas("error", "La fecha de carrera no puede ser más de 10 días después de la fecha de prueba.");
          setTempDatosFormulario((prev) => ({
            ...prev,
            dia: null, // Restablecer la fecha de carrera si no cumple con la regla
          }));
        }
  
        // Validar que la fecha de carrera no sea anterior a la fecha de prueba
        if (moment(diaCarrera).isBefore(diaPrueba)) {
          // Swal.fire({
          //   title: "Error",
          //   text: "La fecha de carrera no puede ser anterior a la fecha de prueba.",
          //   icon: "error",
          // });
          manejarAlertas("error", "La fecha de carrera no puede ser anterior a la fecha de prueba.");

          setTempDatosFormulario((prev) => ({
            ...prev,
            dia: null, // Restablecer la fecha de carrera si no cumple con la regla
          }));
        }
      }
    }
  
    // Validación específica para "Día de prueba"
    if (campo === "dia_prueba") {
      const diaPrueba = nuevaFecha;
      const diaCarrera = tempDatosFormulario.dia;
  
      // Si la fecha de carrera ya está definida, validar la diferencia
      if (diaPrueba && diaCarrera) {
        const diffDays = moment(diaCarrera).diff(moment(diaPrueba), "days");
  
        // Validar la diferencia de días
        if (diffDays > 10) {
          // Swal.fire({
          //   title: "Error",
          //   text: "La fecha de carrera no puede ser más de 10 días después de la fecha de prueba.",
          //   icon: "error",
          // });
          manejarAlertas("error", "La fecha de carrera no puede ser más de 10 días después de la fecha de prueba.");

          setTempDatosFormulario((prev) => ({
            ...prev,
            dia: null, // Restablecer la fecha de carrera si no cumple con la regla
          }));
        }
  
        // Validar que la fecha de carrera no sea anterior a la fecha de prueba
        if (moment(diaCarrera).isBefore(diaPrueba)) {
          // Swal.fire({
          //   title: "Error",
          //   text: "La fecha de carrera no puede ser anterior a la fecha de prueba.",
          //   icon: "error",
          // });
          manejarAlertas("error", "La fecha de carrera no puede ser anterior a la fecha de prueba.");

          setTempDatosFormulario((prev) => ({
            ...prev,
            dia: null, // Restablecer la fecha de carrera si no cumple con la regla
          }));
        }
      }
    }
  };

  // Guardar/Actualizar carrera
  const guardarCarrera = async () => {
    try {
      const url = idUnico
        ? process.env.REACT_APP_DOMINIO + `/carrera/${idUnico}` // Actualizar
        : process.env.REACT_APP_DOMINIO + `/carrera`; // Crear
      const method = idUnico ? axios.put : axios.post;

      const payload = {
        id_campeonato: parseInt(tempDatosFormulario.id_campeonato),
        id_circuito: parseInt(tempDatosFormulario.id_circuito),
        dia: tempDatosFormulario.dia
          ? moment(tempDatosFormulario.dia).toISOString()
          : null,
        dia_prueba: tempDatosFormulario.dia_prueba
          ? moment(tempDatosFormulario.dia_prueba).toISOString()
          : null,
        diaCierre: tempDatosFormulario.diaCierre
          ? moment(tempDatosFormulario.diaCierre).toISOString()
          : null,
        horarioCierre:
          tempDatosFormulario.diaCierre && tempDatosFormulario.horarioCierre
            ? moment(tempDatosFormulario.diaCierre)
                .set({
                  hour: moment(tempDatosFormulario.horarioCierre).hour(),
                  minute: moment(tempDatosFormulario.horarioCierre).minute(),
                  second: 0,
                })
                .toDate()
            : null,
        inscripcionAbierta: !!inscripcionAbierta,
        requiereSerieCubiertas: !!tempDatosFormulario.requiereSerieCubiertas,
        requierePrecintos: !!tempDatosFormulario.requierePrecintos,
        categorias: tempDatosFormulario.categorias.map((cat) => ({
          id_categoria: cat.id_categoria,
          invitado: !!cat.invitado,
          requiereLicenciaTitular: !!tempDatosFormulario.requiereLicenciaTitularGeneral,
          requiereLicenciaInvitado: cat.invitado
            ? !!tempDatosFormulario.requiereLicenciaInvitadoGeneral
            : false,
        })),
      };
      // console.log("payload:", payload);

      const response = await method(url, payload, HeadersAuth);
      // console.log("lo que se crea", response.data)
      if (response.status === 200) {
        manejarAlertas("success", "Guardado Exitoso");
          setTempDatosFormulario({
            id_campeonato: "",
            id_circuito: "",
            dia: "",
            dia_prueba: "",
            diaCierre: "",
            horarioCierre: "",
            categorias: [],
            requiereSerieCubiertas: false,
            requierePrecintos: false,
            requiereLicenciaTitularGeneral: false,
            requiereLicenciaInvitadoGeneral: false,
          });
          setIdUnico(null);
          setRefresh(Date.now());
          setMostrarBotonLimpiar(false);
          setModoPilotoInvitado(false);
          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true)
            setDataNotificacion(response.data.notificacionSistema);
          }
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  // Cargar datos para edición
  const handleEdit = async (id) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_DOMINIO + `/carrera/${id}`,
        HeadersAuth
      );
      const carrera = response.data;

      const categoriasFormateadas = carrera.CarreraCategoria.map((cat) => ({
        id_categoria: cat.categoria.id,
        invitado: cat.invitado || false,
        requiereLicenciaTitular: cat.requiereLicenciaTitular || false,
        requiereLicenciaInvitado: cat.requiereLicenciaInvitado || false,
      }));

      setTempDatosFormulario({
        id_campeonato: carrera.id_campeonato.toString(),
        id_circuito: carrera.id_circuito.toString(),
        dia: moment(carrera.dia),
        dia_prueba: moment(carrera.dia_prueba),
        diaCierre: carrera.diaCierre ? moment(carrera.diaCierre) : null,
        horarioCierre: carrera.horarioCierre ? moment(carrera.horarioCierre) : null,
        categorias: categoriasFormateadas,
        requiereSerieCubiertas: carrera.requiereSerieCubiertas,
        requierePrecintos: carrera.requierePrecintos,
        requiereLicenciaTitularGeneral: categoriasFormateadas.some(
          (cat) => cat.requiereLicenciaTitular
        ),
        requiereLicenciaInvitadoGeneral: categoriasFormateadas.some(
          (cat) => cat.requiereLicenciaInvitado
        ),
      });
      // console.log(carrera.CarreraCategoria.map((cat) => ({
      //     id_categoria: cat.categoria.id,   // el id real de la categoría
      //     invitado: cat.invitado || false,  // true/false según la carrera
      //   })))
      // setEditarModoInvitado(carrera.CarreraCategoria.some((cat) => cat.invitado === true));
      setIdUnico(id);
      setMostrarBotonLimpiar(true);
      setMostrarFormulario(true);
      setModoPilotoInvitado(carrera.CarreraCategoria.some((cat) => cat.invitado === true));
      setInscripcionAbierta(!!carrera.inscripcionAbierta);
    // setMostrarBotonLimpiar(false);
    } catch (error) {
      // console.error error);
      manejarAlertas("error","Error al cargar datos de la carrera");
    }
  };
  // console.log("el hora", tempDatosFormulario.horarioCierre)

  // Eliminar carrera
  const handlePreEliminarCarrera = (id) => {
    MySwal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción no se puede deshacer.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.get(
            process.env.REACT_APP_DOMINIO + `/carrera/pre-eliminacion/${id}`,
            HeadersAuth
          );

          // console.log("Pre Eliminación:", response.data);

          // Si requiere notificación → abrir modal ANTES de eliminar
          if (response.data.requiereNotificacion) {
            setAbrirModalNotificacion(true);
            setDataNotificacion(response.data.notificacionSistema); 

            // Guardamos ID para eliminar luego
            setEliminarId(id);
            return;
          }

          // Si NO requiere notificación → eliminar directamente
          await eliminarCarrera(id);

        } catch (error) {
          console.error("Error al pre-eliminar la carrera:", error);
          manejarAlertas("error", "No se pudo pre-eliminar la carrera.");
        }
      }
    });
  };

  useEffect(() => {
    if (!abrirModalNotificacion && eliminarId) {
      eliminarCarrera(eliminarId);
      setEliminarId(null);
    }
  }, [abrirModalNotificacion]);

  const eliminarCarrera = async (id) => {
    try {
      // console.log("id que se envía", id)
      const response = await axios.delete(
        `${process.env.REACT_APP_DOMINIO}/carrera/${id}`,
        HeadersAuth
      );

      manejarAlertas("success", "La carrera ha sido eliminada.");
      setRefresh(Date.now());

    } catch (error) {
      console.error("Error al eliminar la carrera:", error);
      manejarAlertas("error", manejarError(error));
    }
  };

  // Cambio de estado (Activa/Reprogramada)
  const abrirModalEstado = (record) => {
    setCarreraEstadoSeleccionada(record);
    setNuevoEstado(record.estado || "ACTIVA");
    setModalEstadoVisible(true);
  };

  const cerrarModalEstado = () => {
    setModalEstadoVisible(false);
    setCarreraEstadoSeleccionada(null);
    setNuevoEstado("ACTIVA");
  };

  const confirmarCambioEstado = async () => {
    try {
      setGuardandoEstado(true);
      await axios.patch(
        process.env.REACT_APP_DOMINIO + `/carrera/${carreraEstadoSeleccionada.id}/estado`,
        { estado: nuevoEstado },
        HeadersAuth
      );

      manejarAlertas("success", "Estado de la carrera actualizado.");
      setRefresh(Date.now());
      cerrarModalEstado();
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    } finally {
      setGuardandoEstado(false);
    }
  };

  const categoriasSeleccionadas = (categorias || []).filter((c) =>
    (tempDatosFormulario.categorias || []).some(
      (cat) => Number(cat.id_categoria) === Number(c.id)
    )
  );

  const categoriasConInvitado = (tempDatosFormulario.categorias || []).filter(
    (cat) => cat.invitado
  );

  const handleLicenciaTitularGeneral = (checked) => {
    setTempDatosFormulario((prev) => ({
      ...prev,
      requiereLicenciaTitularGeneral: checked,
      categorias: prev.categorias.map((cat) => ({
        ...cat,
        requiereLicenciaTitular: checked,
      })),
    }));
  };

  const handleLicenciaInvitadoGeneral = (checked) => {
    setTempDatosFormulario((prev) => ({
      ...prev,
      requiereLicenciaInvitadoGeneral: checked,
      categorias: prev.categorias.map((cat) => ({
        ...cat,
        requiereLicenciaInvitado: cat.invitado ? checked : false,
      })),
    }));
  };

  const cardConfigStyle = {
    border: "1px solid #d5d5d5",
    borderRadius: 10,
    padding: 16,
    backgroundColor: "#fff",
  };

  const iconBoxStyle = {
    color: "#BA1721",
    fontSize: 26,
    marginBottom: 10,
  };

  const cardTitleStyle = {
    fontSize: 18,
    fontWeight: 700,
    color: "#000",
    marginBottom: 10,
  };

  const cardTextStyle = {
    color: "#a7a7a7",
    fontSize: 14,
    margin: 0,
    lineHeight: "18px",
  };

  const opcionesEstado = [
    { id: "ACTIVA", nombre: "Activa" },
    { id: "REPROGRAMADA", nombre: "Reprogramada" },
  ];

  // Configuración de la tabla
  const elScroll = { x: 0 };
  const columns = [
    {
      title: "CAMPEONATO",
      key: "campeonato",
      align: "left",
      render: (record) => `${record.campeonato.nombre_campeonato} (${record.campeonato.año})`,
    },
    {
      title: "CIRCUITO",
      key: "circuito",
      align: "left",
      render: (record) => record.circuito.nombre,
    },
    {
      title: "DÍAS",
      key: "dia",
      align: "right",
      render: (record) =>
        `${moment(record.dia_prueba).format("DD/MM/YYYY")}, ${moment(
          record.dia
        ).format("DD/MM/YYYY")}`,
    },
    {
      title: "CIERRE-INSCRIPCIÓN",
      key: "cierre",
      align: "left",
      render: (record) => {
        const fecha = record.diaCierre ? new Date(record.diaCierre) : null;

        const hora = record.horarioCierre ? new Date(record.horarioCierre) : null

        if (!hora || isNaN(hora)) return "Sin hora";

        if (!fecha || isNaN(fecha)) return "Sin fecha";

        return `${fecha.toLocaleDateString("es-AR")}, ${hora.toLocaleTimeString("es-AR", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })}hs`;
      },
    },
    {
      title: "CATEGORÍAS",
      key: "categorias",
      align: "left",
      render: (record) =>
        record.categorias.map((cat) => cat.categoria).join(", "),
    },
    {
      title: "TIPO DE CARRERA",
      key: "invitado",
      align: "left",
      render: (record) =>
        record.CarreraCategoria.some((cat) => cat.invitado) ? "Carrera con invitados" : "Carrera común",
    },
    {
      title: "ESTADO",
      key: "estado",
      align: "center",
      sorter: (a, b) => (a.estado === "REPROGRAMADA") - (b.estado === "REPROGRAMADA"),
      render: (record) => {
        const esActiva = record.estado !== "REPROGRAMADA";

        return (
          <div
            style={{
              fontSize: "12px",
              padding: "2px 4px",
              color: esActiva ? "#52C41A" : "#FA8C16",
              fontWeight: "600",
            }}
          >
            {esActiva ? "Activa" : "Reprogramada"}
          </div>
        );
      },
    },
    {
      title: "OPCIONES",
      key: "opciones",
      align: "center",
      render: (_, record) => (
        <>
          <SettingOutlined
            title="Ver configuración"
            className="iconos-tablas"
            style={{ color: "#233463", cursor: "pointer", marginRight: "10px" }}
            onClick={() => {
              setCarreraConfigSeleccionada(record);
              setModalConfigDetalleVisible(true);
            }}
          />
          <SyncOutlined
            title={`Estado: ${record.estado === "REPROGRAMADA" ? "Reprogramada" : "Activa"}`}
            className="iconos-tablas"
            style={{
              color: record.estado === "REPROGRAMADA" ? "#FA8C16" : "#52C41A",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={() => abrirModalEstado(record)}
          />
          <FaRegEdit
            onClick={() => handleEdit(record.id)}
            className="iconos-tablas"
            style={{ color: "blue", cursor: "pointer", marginRight: "10px" }}
          />
          <FaRegTrashAlt
            onClick={() => handlePreEliminarCarrera(record.id)}
            className="iconos-tablas"
            style={{ color: "red", cursor: "pointer" }}
          />
        </>
      ),
    },
  ];

  const esTelefono = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Gestión de Carreras</h1>
      </section>

      {/* Formulario */}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            padding: "20px",
            margin: "0 auto",
          }}
        >
          {mostrarFormulario && (
            <Form layout="vertical" onFinish={guardarCarrera}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "1em",
                }}
              >
                <h1 className="titulos-secundarios">Datos de la carrera</h1>{" "}
                {mostrarBotonLimpiar && (
                  <BotonPrincipal
                    texto="Nueva carrera"
                    onClick={limpiarCampos}
                  />
                )}
                {" "}
              </div>
              <hr></hr>
              <Row className="rowAdmin" gutter={16} align="center">
                <Col xs={24} sm={8} style={{ width: "100%" }}>
                  <Form.Item
                    style={{
                      width: "100%",
                    }}
                  >
                    <SelectCustom
                      idCampo={"id_campeonato"}
                      nombreCampo={"Campeonato"}
                      elPlaceholder={"Seleccioná una opción"}
                      arrayOpciones={campeonatos.length > 0 ? campeonatos : []}
                      textoOpciones="label"
                      required={true}
                      onChange={handleChange}
                      elValue={tempDatosFormulario.id_campeonato || ""}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8} style={{ width: "100%" }}>
                  <Form.Item
                    style={{
                      width: "100%",
                    }}
                  >
                    <SelectCustom
                      idCampo={"id_circuito"}
                      nombreCampo={"Circuito"}
                      elPlaceholder={"Seleccioná una opción"}
                      arrayOpciones={circuitos.length > 0 ? circuitos : []}
                      textoOpciones={"nombre"}
                      required={true}
                      onChange={handleChange}
                      elValue={tempDatosFormulario.id_circuito || ""}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={8} style={{ width: "100%", marginBottom: "1.5em" }}>
                  <InputCustomDate
                    idCampo="dia_prueba"
                    nombreCampo="Día de prueba"
                    tipo="date"
                    min={null} // No se establece un límite mínimo inicialmente
                    max={null} // No se establece un límite máximo inicialmente
                    elValue={
                      tempDatosFormulario.dia_prueba
                        ? moment(tempDatosFormulario.dia_prueba).format("YYYY-MM-DD")
                        : ""
                    }
                    required
                    onChange={(e) => handleFechaChange(e, "dia_prueba")}
                  />
                </Col>
              </Row>

              <Row className="rowAdmin" gutter={16} align="center">
                <Col xs={24} sm={8} style={{ width: "100%", marginBottom: "1.5em" }}>
                  <InputCustomDate
                    idCampo="dia"
                    nombreCampo="Día Carrera"
                    tipo="date"
                    min={
                      tempDatosFormulario.dia_prueba
                        ? moment(tempDatosFormulario.dia_prueba).format("YYYY-MM-DD")
                        : null
                    } // La fecha mínima para "Día Carrera" es la fecha de "Prueba"
                    max={
                      tempDatosFormulario.dia_prueba
                        ? moment(tempDatosFormulario.dia_prueba)
                          .add(10, "days")
                          .format("YYYY-MM-DD")
                        : null
                    } // La fecha máxima para "Día Carrera" es 10 días después de "Prueba"
                    elValue={
                      tempDatosFormulario.dia
                        ? moment(tempDatosFormulario.dia).format("YYYY-MM-DD")
                        : ""
                    }
                    required
                    onChange={(e) => handleFechaChange(e, "dia")}
                  />
                </Col>
                <Col xs={24} sm={8} style={{ width: "100%", marginBottom: "1.5em" }}>
                  <p className="nombre-campo">Inscripción</p>
                  <label
                    style={{
                      border: "1px solid #d5d5d5",
                      borderRadius: "6px",
                      padding: "4px 12px",
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      gap: "6px",
                      width: "100%",
                    }}
                  >
                    <Checkbox
                      checked={inscripcionAbierta}
                      onChange={(e) => handleInscripcionAbiertaChange(e.target.checked)}
                    />
                    Inscripción abierta
                  </label>
                </Col>

                {inscripcionAbierta && (
                  <>
                    <Col xs={24} sm={4} style={{ width: "100%", marginBottom: "1.5em" }}>
                      <InputCustomDate
                        idCampo="diaCierre"
                        nombreCampo="Día de cierre"
                        tipo="date"
                        min={null}
                        max={
                          tempDatosFormulario.dia_prueba
                            ? moment(tempDatosFormulario.dia_prueba).format("YYYY-MM-DD")
                            : null
                        }
                        elValue={
                          tempDatosFormulario.diaCierre
                            ? moment(tempDatosFormulario.diaCierre).format("YYYY-MM-DD")
                            : ""
                        }
                        onChange={(e) => handleFechaChange(e, "diaCierre")}
                      />
                    </Col>
                    <Col xs={24} sm={4} style={{ width: "100%", marginBottom: "1.5em" }}>
                      <SelectCustomDate
                        idCampo="horarioCierre"
                        nombreCampo="Horario de cierre"
                        elPlaceholder={"Seleccioná un horario"}
                        elValue={
                          tempDatosFormulario.horarioCierre
                            ? dayjs(tempDatosFormulario.horarioCierre).format("HH:mm")
                            : null
                        }
                        onChange={(e) => handleHoraChange(e, "horarioCierre")}
                      />
                    </Col>
                  </>
                )}
              </Row>

              <Row gutter={16} align="center">
                <Col xs={24} sm={24} style={{ width: "100%" }}>
                  <Form.Item
                    label={
                      <span
                        style={{
                          color: "#bbbbbb",
                          marginBottom: "0.5em",
                        }}
                      >
                        Categorías
                      </span>
                    }
                    
                  >
                    <Checkbox.Group
                      value={(tempDatosFormulario.categorias || []).map((cat) => cat.id_categoria)}
                      onChange={handleCategoriaChange}
                      style={{ width: "100%" }}
                    >
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                        {(categorias || []).map((categoria) => (
                          <label
                            key={categoria.id}
                            style={{
                              border: "1px solid #d5d5d5",
                              borderRadius: "6px",
                              padding: "8px 12px",
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              gap: "6px",
                            }}
                          >
                            <Checkbox value={categoria.id} />
                            {categoria.categoria}
                          </label>
                        ))}
                      </div>
                    </Checkbox.Group>
                  </Form.Item>
                </Col>
              </Row>

              {tempDatosFormulario.categorias &&
                tempDatosFormulario.categorias.length > 0 && (
                  <Row gutter={16} align="middle" style={{ marginBottom: 20 }}>
                    <Col xs={24} sm={8}>
                      <Button
                        type="primary"
                        style={{ backgroundColor: "#233463", color: "#fff", width: "100%", fontSize: 20 }}
                        onClick={() => setModalConfiguracionCarrera(true)}
                      >
                        Configuración
                      </Button>
                    </Col>
                  </Row>
                )}

              <Row gutter={16} align="middle">
                {/* Cuarta columna: Botón de acción */}
                <Col xs={24} sm={8}className="botonesResponsive"
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="boton-principal"
                    style={{
                      width: "100%", //
                    }}
                  >
                    {idUnico ? "Actualizar" : "Guardar"}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </section>

      {/* Tabla de resultados */}
      <div
        className="botonDescargar"
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "flex-end",
           padding:"0 16px"
        }}
      >
        {" "}
        <br></br>
        <TablaCompleta
          tituloPDF={"carreras"}
          elScroll={elScroll}
          columns={columns}
          fetchDatos={fetchDatos.length > 0 ? fetchDatos : []}
          rowKey={"id"}
          gestionTabla={
            <Row style={{ gap: "10px" }}>
              {!mostrarFormulario && (
                <BotonPrincipal
                  texto={esTelefono ? <PlusOutlined /> : "Agregar"}
                  onClick={mostrarFormularioHandler}
                />
              )}
            </Row>
          }
          tituloBanner={"Carreras"}
          idAsociacion={sesion.id_asociacion}
        />
      </div>
      <Modal
        open={modalConfiguracionCarrera}
        onCancel={() => setModalConfiguracionCarrera(false)}
        footer={null}
        centered
        width={620}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <SettingOutlined style={{ color: "#BA1721", fontSize: 26 }} />
            <span style={{ fontSize: 22, fontWeight: 700 }}>
              Configuración de la carrera
            </span>
          </div>
        }
      >
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={cardConfigStyle}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
              <div>
                <img src={ruedaRoja} alt="Cubiertas" style={{ width: 26, height: 26, marginBottom: 10 }} />

                <p style={cardTitleStyle}>Número de cubiertas</p>

                <p style={cardTextStyle}>
                  Si está activado, el piloto no podrá confirmar asistencia hasta cargar las 4 cubiertas.
                </p>
              </div>

              <Switch
                checked={!!tempDatosFormulario.requiereSerieCubiertas}
                onChange={(checked) =>
                  setTempDatosFormulario((prev) => ({
                    ...prev,
                    requiereSerieCubiertas: checked,
                  }))
                }
                style={{
                  backgroundColor: tempDatosFormulario.requiereSerieCubiertas      
                  ? "#223463" 
                  : "#BA1721", 
                }}
              />
            </div>
          </div>

          <div style={cardConfigStyle}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
              <div>
                <SafetyCertificateOutlined style={iconBoxStyle} />

                <p style={cardTitleStyle}>Número de precintos</p>

                <p style={cardTextStyle}>
                  Si está activado, el piloto no podrá confirmar asistencia hasta cargar el precinto de motor.
                </p>
              </div>

              <Switch
                checked={!!tempDatosFormulario.requierePrecintos}
                onChange={(checked) =>
                  setTempDatosFormulario((prev) => ({
                    ...prev,
                    requierePrecintos: checked,
                  }))
                }
                style={{
                  backgroundColor: tempDatosFormulario.requierePrecintos
                  ? "#223463"
                  : "#BA1721",
                }}
              />
            </div>
          </div>

          <div style={cardConfigStyle}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
              <div>
                <FileProtectOutlined style={iconBoxStyle} />

                <p style={cardTitleStyle}>Licencia médica</p>

                <p style={cardTextStyle}>
                  Si está activado, el piloto deberá cargar su licencia médica para poder confirmar asistencia.
                </p>
              </div>

              <Switch
                checked={!!tempDatosFormulario.requiereLicenciaTitularGeneral}
                onChange={handleLicenciaTitularGeneral}
                style={{
                  backgroundColor: tempDatosFormulario.requiereLicenciaTitularGeneral      
                  ? "#223463" 
                  : "#BA1721", 
                }}
              />
            </div>
          </div>

          <div style={cardConfigStyle}>
            <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
              <div>
                <DashboardOutlined style={iconBoxStyle} />

                <p style={cardTitleStyle}>Carrera con invitado</p>

                <p style={cardTextStyle}>
                  Si está activado, la carrera habilita que el piloto lleve un piloto invitado para las categorías seleccionadas debajo.
                </p>
              </div>

              <Switch
                checked={!!modoPilotoInvitado}
                onChange={handleModoInvitadoGeneral}
                style={{
                  backgroundColor: modoPilotoInvitado      
                  ? "#223463" 
                  : "#BA1721", 
                }}
              />
            </div>
          </div>

          {modoPilotoInvitado && (
            <>
              <div style={cardConfigStyle}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: 16 }}>
                  <div>
                    <FileProtectOutlined style={iconBoxStyle} />

                    <p style={cardTitleStyle}>Licencia médica de invitado</p>

                    <p style={cardTextStyle}>
                      Si está activado, el piloto invitado tendrá que cargar su licencia médica para la confirmación de asistencia.
                    </p>
                  </div>

                  <Switch
                    checked={!!tempDatosFormulario.requiereLicenciaInvitadoGeneral}
                    onChange={handleLicenciaInvitadoGeneral}
                    style={{
                      backgroundColor: tempDatosFormulario.requiereLicenciaInvitadoGeneral      
                      ? "#223463" 
                      : "#BA1721", 
                    }}
                  />
                </div>
              </div>

              <div style={{ ...cardConfigStyle, marginTop: 18 }}>
                <TeamOutlined style={iconBoxStyle} />

                <p style={cardTitleStyle}>Categorías con invitado</p>

                <p style={{ ...cardTextStyle, marginBottom: 18 }}>
                  Seleccioná las categorías que tendrán piloto invitado.
                </p>

                <Checkbox.Group
                  value={(tempDatosFormulario.categorias || [])
                    .filter((cat) => cat.invitado)
                    .map((cat) => Number(cat.id_categoria))}
                  onChange={handleCategoriaInvitadoChange}
                  style={{ width: "100%" }}
                >
                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {categoriasSeleccionadas.map((c) => (
                      <label
                        key={c.id}
                        style={{
                          border: "1px solid #d5d5d5",
                          borderRadius: 6,
                          padding: "8px 12px",
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          gap: 8,
                          minWidth: 150,
                        }}
                      >
                        <Checkbox value={c.id} />
                        {c.categoria}
                      </label>
                    ))}
                  </div>
                </Checkbox.Group>
              </div>
            </>
          )}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 12,
            }}
          >
            <Button 
              type="primary"
              style={{ backgroundColor: "#BA1721", color: "#fff", width: "100%", fontSize: 20 }}
              onClick={() => setModalConfiguracionCarrera(false)}>
              Cerrar
            </Button>

            <Button
              type="primary"
              style={{ backgroundColor: "#233463", color: "#fff", width: "100%", fontSize: 20 }}
              onClick={() => setModalConfiguracionCarrera(false)}
            >
              Guardar configuración
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        open={modalConfigDetalleVisible}
        onCancel={() => setModalConfigDetalleVisible(false)}
        footer={null}
        centered
        width={620}
        title={
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <SettingOutlined style={{ color: "#BA1721", fontSize: 26 }} />
            <span style={{ fontSize: 22, fontWeight: 700 }}>
              Configuración de la carrera
            </span>
          </div>
        }
      >
        {carreraConfigSeleccionada && (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div style={cardConfigStyle}>
              <img src={ruedaRoja} alt="Cubiertas" style={{ width: 26, height: 26, marginBottom: 10 }} />
              <p style={cardTitleStyle}>Número de cubiertas</p>
              <p style={cardTextStyle}>
                {carreraConfigSeleccionada.requiereSerieCubiertas
                  ? "Obligatorio para confirmar asistencia."
                  : "No obligatorio."}
              </p>
            </div>

            <div style={cardConfigStyle}>
              <SafetyCertificateOutlined style={iconBoxStyle} />
              <p style={cardTitleStyle}>Número de precintos</p>
              <p style={cardTextStyle}>
                {carreraConfigSeleccionada.requierePrecintos
                  ? "Obligatorio para confirmar asistencia."
                  : "No obligatorio."}
              </p>
            </div>

            <div style={cardConfigStyle}>
              <FileProtectOutlined style={iconBoxStyle} />
              <p style={cardTitleStyle}>Licencia médica del titular</p>
              <p style={cardTextStyle}>
                {carreraConfigSeleccionada.CarreraCategoria?.some(
                  (cat) => cat.requiereLicenciaTitular
                )
                  ? "Obligatoria para confirmar asistencia."
                  : "No obligatoria."}
              </p>
            </div>

            <div style={cardConfigStyle}>
              <DashboardOutlined style={iconBoxStyle} />
              <p style={cardTitleStyle}>Carrera con invitado</p>
              <p style={cardTextStyle}>
                {carreraConfigSeleccionada.CarreraCategoria?.some((cat) => cat.invitado)
                  ? "La carrera permite piloto invitado."
                  : "La carrera no permite piloto invitado."}
              </p>
            </div>

            {carreraConfigSeleccionada.CarreraCategoria?.some((cat) => cat.invitado) && (
              <>
                <div style={cardConfigStyle}>
                  <FileProtectOutlined style={iconBoxStyle} />
                  <p style={cardTitleStyle}>Licencia médica de invitado</p>
                  <p style={cardTextStyle}>
                    {carreraConfigSeleccionada.CarreraCategoria?.some(
                      (cat) => cat.requiereLicenciaInvitado
                    )
                      ? "Obligatoria para confirmar asistencia si el piloto lleva invitado."
                      : "No obligatoria."}
                  </p>
                </div>

                <div style={cardConfigStyle}>
                  <TeamOutlined style={iconBoxStyle} />
                  <p style={cardTitleStyle}>Categorías con invitado</p>

                  <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                    {carreraConfigSeleccionada.CarreraCategoria
                      ?.filter((cat) => cat.invitado)
                      .map((cat) => (
                        <span
                          key={cat.id_categoria}
                          style={{
                            border: "1px solid #d5d5d5",
                            borderRadius: 6,
                            padding: "8px 12px",
                            fontSize: 14,
                            color: "#000",
                          }}
                        >
                          {cat.categoria?.categoria || "Categoría"}
                        </span>
                      ))}
                  </div>
                </div>
              </>
            )}

            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
              <Button 
                type="primary"
                style={{ backgroundColor: "#BA1721", color: "#fff", width: "100%", fontSize: 20 }}
                onClick={() => setModalConfigDetalleVisible(false)}>
                Cerrar
              </Button>
            </div>
          </div>
        )}
      </Modal>

      <Modal
        open={modalEstadoVisible}
        onCancel={cerrarModalEstado}
        footer={null}
        centered
        width={420}
        title={
          <span style={{ fontSize: 22, fontWeight: 700 }}>
            Cambiar estado de la carrera
          </span>
        }
      >
        {carreraEstadoSeleccionada && (
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <p style={cardTextStyle}>
              Si reprogramás la carrera, las fechas se mostrarán como "a definir" en la app hasta que se confirme una nueva fecha.
            </p>

            <SelectCustom
              idCampo="nuevoEstado"
              nombreCampo="Estado"
              elPlaceholder="Seleccioná un estado"
              arrayOpciones={opcionesEstado}
              textoOpciones="nombre"
              elValue={nuevoEstado}
              onChange={(e) => setNuevoEstado(e.target.value)}
            />

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 12 }}>
              <Button
                type="primary"
                style={{ backgroundColor: "#BA1721", color: "#fff", width: "100%", fontSize: 20 }}
                onClick={cerrarModalEstado}
              >
                Cancelar
              </Button>

              <Button
                type="primary"
                loading={guardandoEstado}
                style={{ backgroundColor: "#233463", color: "#fff", width: "100%", fontSize: 20 }}
                onClick={confirmarCambioEstado}
              >
                Guardar
              </Button>
            </div>
          </div>
        )}
      </Modal>

      {dataNotificacion.length > 0 && (
        <ModalNotificacion
          open={abrirModalNotificacion}
          onCancel={() => setAbrirModalNotificacion(false)}
          datos={dataNotificacion}
          id_asociacion={sesion.id_asociacion}
          HeadersAuth={HeadersAuth}
          setAlerta={setAlerta}
        />
      )}
    </>
  );
};